<template>
    <div class="col-sm-12 col-xl-6">
        <div class="card">
            <div class="card-header pb-0">
                <h3>Contextmenu Tree</h3>
            </div>
            <div class="card-body">
                <div id="treeBasic">
                    <Tree :nodes="menu" :use-icon="false" draggable />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import treeMixin from "@/mixins/treeMixin"
import Tree from "vue3-tree";
import "vue3-tree/dist/style.css"
export default {
    mixins: [treeMixin],
    components: {
        Tree
    },
}
</script>